import {
    FETCH_SIGNUP_CONTENT,
    FETCH_SIGNUP_CONTENT_SUCCESS,
    FETCH_SIGNUP_CONTENT_FAILED,
    SIGNUP_MESSAGE,
    SIGNUP_MESSAGE_SUCCESS,
    SIGNUP_MESSAGE_FAILED,
    VERIFY_MESSAGE,
    VERIFY_MESSAGE_SUCCESS,
    VERIFY_MESSAGE_FAILED,
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
    authToken: localStorage.getItem("authToken"),
    mem_type: localStorage.getItem("mem_type"),
};

export default function (state = initialState, { type, payload }) {
    switch (type) {
        case FETCH_SIGNUP_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_SIGNUP_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_SIGNUP_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case SIGNUP_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case SIGNUP_MESSAGE_SUCCESS:
            localStorage.setItem("authToken", payload.authToken);
            localStorage.setItem("mem_type", payload.mem_type);
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case SIGNUP_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        case VERIFY_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case VERIFY_MESSAGE_SUCCESS:
            localStorage.setItem("authToken", payload.authToken);
            localStorage.setItem("mem_type", payload.mem_type);
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case VERIFY_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        default:
            return state;
    }
}
